import { apiUrls } from 'consts'
import reorderAll from 'utils/reorderAll'

interface getReorderRowsProps {
  data: Array<any>
}

const reorderRows = async (props: getReorderRowsProps) => {
  let data = await reorderAll(apiUrls.types, props.data)

  return data
}

export default reorderRows
